import './../../external_lib/d3-color/src/color.js';
import './../../external_lib/d3-color/src/lab.js';
import cubehelix from './../../external_lib/d3-color/src/cubehelix.js';
import '../../../d3-interpolate/dist/d3-interpolate.js';
import { exports as d3InterpolateExports } from '../../../../_virtual/d3-interpolate.js';
var ie = d3InterpolateExports.interpolateCubehelixLong(cubehelix(300, 0.5, 0.0), cubehelix(-240, 0.5, 1.0));
export { ie as default };
//# sourceMappingURL=cubehelix.js.map
